(() => {
  'use strict';

  if (customElements.get('rv-product-recommendations')) return;

  class RvProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rvSourceState !== 'allowed') {
        this.failClosed();
        return;
      }

      if (this.classList.contains('is-ready')) {
        const validResults = this.getValidResults(this);
        if (!validResults) {
          this.failClosed();
          return;
        }

        this.hidden = false;
        this.removeAttribute('aria-busy');
        return;
      }

      if (this.dataset.rvLoading === 'true' || !this.dataset.url) return;
      this.dataset.rvLoading = 'true';
      this.controller = new AbortController();
      this.load();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    getValidResults(root) {
      const results = root.querySelector('[data-rv-recommendations-results]');
      if (!results) return null;

      const items = results.querySelectorAll('.rv-recommendations__item');
      if (items.length < 1 || items.length > 4) return null;

      const declaredCount = Number.parseInt(root.dataset.rvCandidateCount || '', 10);
      if (Number.isFinite(declaredCount) && declaredCount !== items.length) return null;

      return { results, count: items.length };
    }

    failClosed() {
      this.classList.remove('is-ready');
      this.hidden = true;
    }

    async load() {
      try {
        const response = await window.fetch(this.dataset.url, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          cache: 'no-store',
          signal: this.controller.signal
        });
        if (!response.ok) return;

        const contentType = response.headers.get('content-type') || '';
        if (!contentType.includes('text/html')) return;

        const responseText = await response.text();
        if (this.controller.signal.aborted) return;

        const parsed = new window.DOMParser().parseFromString(responseText, 'text/html');
        const responseShell = parsed.querySelector('rv-product-recommendations');
        if (!responseShell || responseShell.dataset.rvSourceState !== 'allowed') return;
        if (responseShell.dataset.rvSourceArchive !== this.dataset.rvSourceArchive) return;

        const validResults = this.getValidResults(responseShell);
        if (!validResults) return;

        validResults.results.querySelectorAll('script, style, iframe, object, embed').forEach((element) => element.remove());
        this.replaceChildren(validResults.results);
        this.dataset.rvCandidateCount = String(validResults.count);
        this.dataset.rvSelectionMode = responseShell.dataset.rvSelectionMode || this.dataset.rvSelectionMode || '';
        this.dataset.rvAvailableFallbackCount = responseShell.dataset.rvAvailableFallbackCount || '0';
        this.dataset.rvAvailableFallbackHandle = responseShell.dataset.rvAvailableFallbackHandle || '';
        this.classList.add('is-ready');
        this.hidden = false;
        this.dispatchEvent(new CustomEvent('rv:recommendations:loaded', {
          bubbles: true,
          detail: {
            count: validResults.count,
            archive: this.dataset.rvSourceArchive === 'true'
          }
        }));
      } catch (error) {
        if (error.name !== 'AbortError') {
          // Recommendation failures deliberately leave the optional section hidden.
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('rv-product-recommendations', RvProductRecommendations);
})();
